import { render } from "./CompanyBusinessCardSeal.vue?vue&type=template&id=fda6f922&scoped=true&ts=true"
import script from "./CompanyBusinessCardSeal.vue?vue&type=script&lang=ts"
export * from "./CompanyBusinessCardSeal.vue?vue&type=script&lang=ts"

import "./CompanyBusinessCardSeal.vue?vue&type=style&index=0&id=fda6f922&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fda6f922"]])

export default __exports__